export const RUSD_address = {
  ETH: "0xf5309d4971d187c1f315304442d45f84c6353a77",
  BSC: "0x6b3b95B0c84f35c9c505fff8C2F35Ee2e502a44D",
};

export const rpc = {
  ETH: "https://mainnet.infura.io/v3/b4f414af9be54b1aa788f5fa2ed4020d",
  BSC: "https://bsc-rpc.publicnode.com",
  MAAL: "https://node1-mainnet.maalscan.io",
};
